<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { Compass, House } from 'lucide-vue-next'
import Button from '@/components/ui/Button.vue'

const { t } = useI18n()
const router = useRouter()

function goHome(): void {
  router.push('/dashboard').catch(() => {
    /* ignore */
  })
}

function goBack(): void {
  if (window.history.length > 1) {
    router.back()
  } else {
    goHome()
  }
}
</script>

<template>
  <div class="flex min-h-screen items-center justify-center bg-bg-base p-4">
    <div class="text-center" role="status" aria-live="polite">
      <Compass :size="48" class="mx-auto text-fg-subtle" aria-hidden="true" />
      <h1 class="mt-4 text-2xl font-semibold text-fg">404</h1>
      <p class="mt-1 text-sm text-fg-muted">{{ t('errors.notFound') }}</p>
      <p class="mt-1 text-xs text-fg-subtle">{{ t('errorBoundary.notFoundHint') }}</p>
      <div class="mt-6 flex items-center justify-center gap-2">
        <Button variant="ghost" size="md" @click="goBack">
          {{ t('common.back') }}
        </Button>
        <Button variant="primary" size="md" @click="goHome">
          <template #icon><House :size="14" /></template>
          {{ t('common.home') }}
        </Button>
      </div>
    </div>
  </div>
</template>
